import React, {Component} from "react";
import generateContentDataObject from '../../helpers/editor/generateContentDataObject'
import {callToActionOptions} from "../../data/callToActionOptions";
import {pressLogos} from "../../data/urls";
import {linkOrButtonOptions} from "../../data/linkOrButtonOptions";
import {buttonStyles} from "../../data/buttonStyles";
import {pictogramOptions} from "../../data/pictogramOptions";
import { displayTitleMarkupText } from "../../helpers/content_displayers/displayTitleMarkupText";
import { displaySubtitleMarkupText } from "../../helpers/content_displayers/displaySubtitleMarkupText";
import Pictogram from "../component_molecules/Pictogram";
import WebsiteButton from "../component_molecules/WebsiteButton";
import WebsiteCTA from "../component_molecules/WebsiteCTA";

interface Props {
    componentItem: any,
    checkIsEmptyContent: any,
    saveContentInStore: any,
    connectDefaultFormIntegration: any, //we need this to connect an integration to forms in CTAs
    isDarkBg: boolean,
}

class Header49 extends Component<Props>{
    generator = new generateContentDataObject();

    componentWillMount(): void {
      const { isDefaultEmpty, defaultCtaOption } = this.props.componentItem;
        //check if the component has not content (when just added). if so, generate some default dummy content.
        // also change inputs tooltips, placeholders text if needed. E.g. when a component needs an image of a particular size.
        if(this.props.checkIsEmptyContent()){
            //generate defaultContent{}. Use special methods of the generateContentDataObject class;

            this.props.saveContentInStore(this.generator.setUpTitle({
                titleText: 'Customer Care Center',
                isDefaultEmpty
            }));
            this.props.saveContentInStore(this.generator.setUpCta({
                activeOption: defaultCtaOption || callToActionOptions.buttons,
                priority: 500,

                formButtonStyleColor: buttonStyles.regular.whiteBg,
                buttons: [
                    this.generator.createButtonContentObject({
                        buttonType: linkOrButtonOptions.link,
                        buttonTitle: "Get it",
                        buttonHref: '/sign-up',
                        buttonStyleType: buttonStyles.regular.typeTitle,
                        buttonColor: buttonStyles.regular.whiteBg,
                        buttonIsTargetBlank: false,
                        pillPrefix: 'Whoa!'
                    }),

                    this.generator.createButtonContentObject({
                        buttonType: linkOrButtonOptions.link,
                        buttonTitle: "About us",
                        buttonHref: '/product',
                        buttonStyleType: buttonStyles.regular.typeTitle,
                        buttonColor: buttonStyles.regular.whiteOutline,
                        buttonIsTargetBlank: false,
                        pillPrefix: 'New'
                    }),

                    // ghost object
                    this.generator.createButtonContentObject({
                        buttonType: linkOrButtonOptions.link,
                        buttonTitle: '',
                        buttonHref: '',
                        buttonStyleType: buttonStyles.ghost.typeTitle,
                        buttonColor: buttonStyles.ghost.whiteOutline,
                        buttonIsTargetBlank: false,
                        pillPrefix: 'View'
                    })
                ],
                isDefaultEmpty

            }));
            this.props.saveContentInStore(this.generator.setUpPictograms({
                fieldTitle: {default: "Side icon"},
                label: {default: "Pick the side icon:"},

                priority: 400,

                items: [
                    {
                        pictogram: this.generator.createPictogramContentObject({
                            type: pictogramOptions.emoji.title,
                            emojiSrc: '1f3e2.svg'
                        })
                    }
                ]
            }));
            this.props.saveContentInStore(this.generator.setUpSubtitleText({isDefaultEmpty}));
            this.props.saveContentInStore(this.generator.setUpFeatures({

                priority: 200,
                maxItems: 3,

                hasSubtitle: false,
                hasText: true,
                hasPictogram: true,
                hasHighlight: false,
                hasHighlightInfo: false,
                hasButton: true,

                buttonTypes: [buttonStyles.ghost.typeTitle, buttonStyles.regular.typeTitle, buttonStyles.pill.typeTitle, buttonStyles.mobileAppStore.typeTitle],

                items: [
                    this.generator.createFeatureContentObject({
                        title: 'Build Instantly',
                        text: 'Cur spatii congregabo. Raptus, talis solems aliquando imperium de alter, albus boreas.',
                        button: this.generator.createButtonContentObject({
                            buttonType: linkOrButtonOptions.link,
                            buttonTitle: "Read here",
                            buttonHref: '/',
                            buttonStyleType: buttonStyles.ghost.typeTitle,
                            buttonColor: buttonStyles.ghost.accentOutline,
                        })
                    }),
                    this.generator.createFeatureContentObject({
                        title: 'Fully Responsive',
                        text: 'Ecce. Cum ausus studere, omnes demolitionees acquirere castus, dexter ignigenaes.',
                        button: this.generator.createButtonContentObject({
                            buttonType: linkOrButtonOptions.link,
                            buttonTitle: "Read here",
                            buttonHref: '/',
                            buttonStyleType: buttonStyles.ghost.typeTitle,
                            buttonColor: buttonStyles.ghost.accentOutline,
                        })
                    }),
                    this.generator.createFeatureContentObject({
                        title: 'Unlimited Flexibility',
                        text: 'Calceus de germanus cannabis, amor tata! Sunt diatriaes consumere rusticus, altus decores.',
                        button: this.generator.createButtonContentObject({
                            buttonType: linkOrButtonOptions.link,
                            buttonTitle: "Read here",
                            buttonHref: '/',
                            buttonStyleType: buttonStyles.ghost.typeTitle,
                            buttonColor: buttonStyles.ghost.accentOutline,
                        })
                    }),

                    this.generator.createFeatureContentObject({
                        title: '',
                        text: 'Calceus de germanus cannabis, amor tata! Sunt diatriaes consumere rusticus, altus decores.',
                        button: this.generator.createButtonContentObject({
                            buttonType: linkOrButtonOptions.link,
                            buttonTitle: "Read here",
                            buttonHref: '/',
                            buttonStyleType: buttonStyles.ghost.typeTitle,
                            buttonColor: buttonStyles.ghost.accentOutline,
                        })
                    }),
                ],
                isDefaultEmpty

            }));

        }
    }

    render(){
        // these variables contain content. we need to wait a little before content schemes with default data will be populated (it happens on the componentWillMount even, each time we launch generator).
        // see the content schema in the helpers/editor/generateContentDataObject.ts
        let title = displayTitleMarkupText(this.props.componentItem.componentData.title.content.markup);
        let subtitleText = displaySubtitleMarkupText(this.props.componentItem.componentData.subtitleText.content.markup);
        let features = this.props.componentItem.componentData.features.content.items;
        let pictogram = this.props.componentItem.componentData.pictograms.content.items[0].pictogram;

        return (

            <header className="header-49">
                <div className="container">
                    <div className="header-49__wrapper">

                        <div className="header-49__text_box">

                            {title.length > 0 && <h1 className={"title-text heading heading--accent " + (this.props.isDarkBg ? 'text-white' : '')} dangerouslySetInnerHTML={{__html: title}}/>}

                            {subtitleText.length > 0 && <p className={"subtitle-text content_box "  + (this.props.isDarkBg ? 'text-white' : '')} dangerouslySetInnerHTML={{__html: subtitleText}}/>}

                            <div className="header-49__buttons_box">
                                <WebsiteCTA componentItem={this.props.componentItem} isDarkBg={this.props.isDarkBg} />
                            </div>
                        </div>

                        <div className="header-49__img_box">
                            <Pictogram 
                              pictogramObject={pictogram}
                              className='header-49__img'
                            />
                        </div>

                    </div>
                </div>

                <div className="container">
                    <ul className="header-49__features_list card-container sh-1">
                        {features && features.map((item:any, key:number) => {
                            if(item.title && item.title !== ''){
                                return (
                                    <li className="header-49__feature" key={'feature-header-49-' + key}>

                                        <div className="header-49__icon">
                                            <Pictogram 
                                              pictogramObject={item.pictogram}
                                              className='header-49__icon'
                                            />
                                        </div>

                                        <div className="header-49__text_box">
                                            <h3 className="def-18_72 title-text--inner header-49__feature_title">{item.title}</h3>
                                            <div className="content-text header-49__text content_box" dangerouslySetInnerHTML={{__html: item.text}}/>

                                            {item.button.href && item.button.title && <WebsiteButton config={{
                                                buttonStyleType: item.button.settings.appearance.styleType,
                                                buttonColor: item.button.settings.appearance.color,
                                                buttonType: linkOrButtonOptions.link,
                                                buttonTitle: item.button.title,
                                                buttonHref: item.button.href,
                                                buttonIsTargetBlank: item.button.isTargetBlank,
                                                buttonMobileAppStoreType: item.button.settings.appearance.mobileAppStoreType,
                                                pillPrefix: item.button.pillPrefix,
                                                pillColor: item.button.settings.appearance.pillColor,
                                                ghostColor: item.button.settings.appearance.ghostColor,
                                            }} />}

                                        </div>
                                    </li>
                                )
                            }else{
                                return (null);
                            }

                        })}
                    </ul>
                </div>
            </header>

        )
    }
}

export default Header49;
